import {
  getColumnNumeric,
  getColumnWidth as getFieldDefaultWidth,
} from 'components/Fields/InlineTableFieldInput';
import { getCellForFieldType } from 'components/Layout/BigTableLayout/InlineCells';
import { isStandardObject } from 'components/Modals/utilities';
import { getBasicColumns } from 'pages/Common/RelatedObjectFields/custom/columns';
import CustomObjectsService from 'services/CustomObjectsService';
import PipelineService from 'services/PipelineService';
import {
  SortableHeadCell,
  getBasicColumnMinWidth,
  parseMinWidth,
} from './shared';
import { FIELD_TYPES } from 'utility/constants';

export const getColumnsForObject = (
  {
    columns,
    fields,
    model,
    preReleaseFeatures,
    fieldsById,
    onResizeColumnWidth,
    onResizeStop,
    getColumnWidth,
    minWidth,
    resizable,
    adornments,
  },
  t
) => {
  const serviceToUse = isStandardObject(model)
    ? CustomObjectsService
    : PipelineService;

  const basicColumns = getBasicColumns({
    model,
    teams: [],
    stages: [],
    fields,
    adornments,
    preReleaseFeatures,
    serviceToUse,
    t,
    supportsInfiniteScroll: true,
  });

  return [
    ...columns.map((c) => {
      if (basicColumns[c.name]) {
        const basicCol = basicColumns[c.name];
        const colMinWidth = getBasicColumnMinWidth(basicCol, minWidth);
        return {
          id: c.id,
          label: c.label,
          ...basicCol,
          headCell: (
            <SortableHeadCell
              column={c}
              getColumnWidth={getColumnWidth}
              onResizeColumnWidth={onResizeColumnWidth}
              onResizeStop={onResizeStop}
              narrowestWidth={parseMinWidth(colMinWidth)}
              minWidth={colMinWidth}
              resizable={resizable}
              numeric={basicCol.headCell?.props?.numeric}
            />
          ),
        };
      }

      const field = fieldsById?.[c.id];
      const fieldAdornments = adornments?.filter(
        (a) => a?.field_type === field?.fieldType
      );
      const fieldMinWidth = getFieldDefaultWidth(field, fieldAdornments) || 200;

      return {
        id: c.id,
        label: c.label,
        headCell: (
          <SortableHeadCell
            column={c}
            getColumnWidth={getColumnWidth}
            onResizeColumnWidth={onResizeColumnWidth}
            onResizeStop={onResizeStop}
            narrowestWidth={fieldMinWidth}
            minWidth={`${fieldMinWidth}px`}
            resizable={resizable}
            numeric={getColumnNumeric(field)}
            hasSorting={field.fieldType !== FIELD_TYPES.Relationship.type}
          />
        ),
        bodyCell: {
          field: { ...field, isReadOnly: true },
          adornments,
          fetchUrl: `custom-objects/${model.id}`,
          model,
          minWidth: `${fieldMinWidth}px`,
          Component: getCellForFieldType(field?.fieldType),
          forceReadOnly: true,
          editable: false,
          disabled: true,
          isCustomObjects: true,
          displayMaskedValue: true,
        },
      };
    }),
  ];
};
